// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"db63feda","585":"3aa6947e","718":"6f6a91ab"}[chunkId] + ".chunk.js";
};